/**
 * Format a rating value to always show 2 decimal places
 * @param {number} rating - The rating value to format
 * @returns {string} - Formatted rating with 2 decimal places
 */
export const formatRating = (rating) => {
    if (rating === null || rating === undefined) {
        return '';
    }
    return rating.toFixed(2);
};

/**
 * Format a review count with thousands separator
 * @param {number} count - The review count to format
 * @returns {string} - Formatted review count with thousands separator
 */
export const formatReviewCount = (count) => {
    if (count === null || count === undefined) {
        return '0';
    }
    return new Intl.NumberFormat('en-US').format(count);
};

/**
 * Get plural form of 'Review' based on count
 * @param {number} count - The review count
 * @returns {string} - 'Review' or 'Reviews'
 */
export const getReviewText = (count) => {
    return count === 1 ? 'Review' : 'Reviews';
};

/**
 * Format the full review count text (e.g. "1,234 Reviews")
 * @param {number} count - The review count
 * @returns {string} - Formatted review count with text
 */
export const formatReviewCountText = (count) => {
    if (!count) {
        return 'No reviews yet';
    }
    return `${formatReviewCount(count)} ${getReviewText(count)}`;
};
